
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_UNLOADER_MAPPING } from '../../common/URLs';
import jwt from 'jwt-decode';
import { DataGrid } from '@mui/x-data-grid';
import { Container, Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Tooltip } from '@mui/material'
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import moment from 'moment';
import { loaderService } from "../../common/custom-loader/loader-service";
import { PROD, PIT_ROLES } from "../../common/constants";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { toast } from 'react-toastify';
import { WBOUnloaderMapping } from "./unloaderMapping";
import { AddIcon, UpdateIcon } from "../../common/icons";
import apiClient from "../../axios";
import DeleteIcon from '@mui/icons-material/Delete';

function WBOUnloaderMappingList() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [mappingList, setMappingList] = useState();
    const onDeleteMapping = (cellValues) => {
 console.log('Delete clicked:', cellValues.row);
 // APIs will be inserted here
};

    const onViewDetails = (cellValues) => {
        navigate('/sidebar/wboUnloaderMappingList/unloaderMapping', {
            state: { selectedRow: cellValues.row }
        });
    }

    const onAddNewMapping = () => {
        navigate('/sidebar/wboUnloaderMappingList/unloaderMapping', {

        });
    }


    useEffect(() => {
        getMappingList();
    }, []);

    const getMappingList = () => {
        loaderService.showLoader()
        apiClient
            .post(
                GET_UNLOADER_MAPPING,
                {
                    "stakeholderType": "",
                    "stakeholderUrn": "",
                    "mappedUserEmailId": "",
                    "mappedUserRoleName": ""
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setMappingList(response.data.unloaderMappingList);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                // toast.error(error.message);

            });
    };


    const columns = [
        { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 130 },
        { field: 'stakeholderUrn', headerName: 'Stakeholder Urn', width: 210 },
        { field: 'mappedUserRoleName', headerName: 'Mapped User Role', width: 210 },
        { field: 'mappedUserEmailId', headerName: 'Mapped User Email', width: 280 },  
       {

  field: 'Action',

  width: 120,

  renderCell: (cellValues) => {

    return (
<>

        {/* Update Button */}
<Tooltip title="Update">
<IconButton

            color="primary"

            onClick={() => onViewDetails(cellValues)}
>
<UpdateIcon />
</IconButton>
</Tooltip>

        {/* Delete Button */}
<Tooltip title="Delete">
<IconButton

            color="error"

            onClick={() => onDeleteMapping(cellValues)}
>
<DeleteIcon />
</IconButton>
</Tooltip>
</>

    );

  },

}
 
    ];

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT80</p>}
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Weighbridge Mapping List
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        {localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge ? null :
                            <>
                                <Stack direction="row" spacing={1}>
                                    <Button startIcon={<AddIcon/>} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onAddNewMapping(e)} >
                                        Create New Mapping
                                    </Button>
                                </Stack>
                            </>
                        }
                    </Stack>
                </Stack>
                <Box sx={{ height: 450, width: "100%" }}>
                    {
                        mappingList &&
                        <DataGrid rows={mappingList}
                            columns={columns}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            components={{ Toolbar: QuickSearchToolbar }}
                        />
                    }
                </Box>
            </Container>
        </>
    );
}
export default WBOUnloaderMappingList;
